export const PLACE_TO_STAY_SCHEMA_URL = 'https://withjoy.com/assets/public/schemas/placeToStayComponentSchemaV1_0_3.json' as const;
export const PLACE_TO_STAY_COMPONENT_TYPE = 'PlaceToStayComponent' as const;
